import moment from "moment";

export default function formattedValues(coveps) {
  const covep = coveps
    // .sort((a, b) => a.data.localeCompare(b.data))
    .map((co) => {
      if (`${co.preco}`.includes(",")) co.preco = co.preco.replace(",", ".");
      return [
        moment.utc(co.data).format("DD-MM-YYYY"),
        co.usuario,
        co.produto,
        co.volume,
        co.preco,
        co.prazo,
        `${co.k_percentual}%` || 0,
        co.concorrente,
        co.zona,
        co.cliente,
        co.empresa,
      ];
    });

  covep.unshift([
    "Data",
    "Usuário",
    "Produto",
    "Volume",
    "Preço",
    "Prazo",
    "Margem PCC",
    "Concorrente",
    "Zona",
    "Cliente",
    "Empresa",
  ]);

  return covep;
}
